export default __webpack_public_path__ + "static/char-s-13-chs-984d1fe9a87a6f5925a382eb9363c1a6.webp";